"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlatOption = exports.Content = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = require("@chakra-ui/react");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FlatOption = (0, _styledComponents.default)(_react.Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between !important;\n\n  color: ", ";\n  background-color: ", " !important;\n  font-weight: normal !important;\n\n  border-radius: ", ";\n  border: none;\n  flex-shrink: 0; // No se encogera cuando sean muchos elementos en el contenedor padre\n\n  &.active {\n    color: #40A8FF;\n    background-color: #194671 !important;\n  }\n\n  &:hover {\n    background-color: #5F646833;\n  }\n\n  &:focus {\n    box-shadow: none;\n  }\n\n  @media (max-width: 480px) {\n    font-size: .8rem !important;\n  }\n"])), props => props.theme.menuOption.color, props => props.theme.menuOption.backgroundColor, props => props.theme.menuOption.borderRadius);
exports.FlatOption = FlatOption;

var Content = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: .8rem;\n"])));

exports.Content = Content;